import { SelectControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

// Define the order options
const orderOptions = [
    { label: __('Title', 'vayu-blocks'), value: 'title' },
    { label: __('Date', 'vayu-blocks'), value: 'date' },
    { label: __('ID', 'vayu-blocks'), value: 'id' },
    { label: __('Author', 'vayu-blocks'), value: 'author' },
    { label: __('Modified', 'vayu-blocks'), value: 'modified' },
    { label: __('Slug', 'vayu-blocks'), value: 'slug' }, 
    { label: __('Comment Count', 'vayu-blocks'), value: 'comment_count' }, 
    { label: __('Random', 'vayu-blocks'), value: 'rand' }, 
];

// OrderControl Component to handle order selection
const OrderByControl = ({orderBy, onChange }) => (
    <SelectControl
        label={__('Order by', 'vayu-blocks')}
        value={`${orderBy}`}
        options={orderOptions}
        onChange={(newOrder) => {
            onChange({ orderBy: newOrder });
        }}
    />
    
);

export default OrderByControl;
